import { EntityKey, GetLocalStoreDocumentListParams } from 'generated/bffDocument/models';
import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const getBase64 = async (file: File): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const res = reader.result as string;

      // remove application type from content string
      return resolve(res.slice(res.search(',') + 1));
    };

    reader.onerror = reject;
  });
};
export const api = {
  fetchLocalDocuments: (
    url: string,
    directDmsMode: boolean,
    entityKey: EntityKey,
    filter: GetLocalStoreDocumentListParams['localStoreDocumentsFilter']
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/local-store-document/documents`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
        channel: ChannelType.MO2_CARE,
        directDmsMode,
        ...entityKey,
        ...filter,
      },
    }),

  uploadStaticDocumentToLocalStore: (
    url: string,
    fileType: string,
    directDmsMode: boolean,
    extId: string,
    entityKey: EntityKey,
    uploadedFileName: string,
    appliedTo?: string,
    objectStoreName?: string,
    contentElementNumber?: string,
    customerRefNo?: string,
    crRefNo?: string,
    orderRefNo?: string,
    contactPersonRefNo?: string
  ): Promise<ExtendedAxiosResponse> => {
    const body = {
      fileType,
      appliedTo,
      objectStoreName,
      uploadedFileName,
      extId,
      contentElementNumber,
      customerRefNo,
      crRefNo,
      orderRefNo,
      contactPersonRefNo,
    };

    return apiClient.post(`${url}/local-store-document`, body, {
      data: body,
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        directDmsMode,
        ...entityKey,
      },
    });
  },

  uploadLocalDocument: async (
    url: string,
    file: File,
    { directDmsMode, entityKey, ...params }: any
  ): Promise<ExtendedAxiosResponse> => {
    const body = {
      fileType: 'GENERAL',
      fileContent: await getBase64(file),
      uploadedFileName: file.name,
      ...params,
    };

    return apiClient.post(`${url}/local-store-document`, body, {
      data: body,
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        directDmsMode,
        ...entityKey,
      },
    });
  },

  deleteLocalStoreDocumentWithRefNo: (
    url: string,
    fileRefNo: string,
    directDmsMode: boolean,
    entityKey: EntityKey
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.delete(`${url}/local-store-document`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        directDmsMode,
        fileRefNo,
        ...entityKey,
      },
    }),

  deleteLocalStoreDocument: (
    url: string,
    directDmsMode: boolean,
    entityKey: EntityKey,
    documentExtId: string,
    objectStoreName: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.delete(`${url}/local-store-document`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        objectStoreName: objectStoreName,
        documentExtID: documentExtId,
        directDmsMode,
        ...entityKey,
      },
    }),

  getLocalStoreDocumentDetail: (url: string, fileRefNo: string, entityKey: EntityKey): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/local-store-document/${fileRefNo}`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        forceCheck: false,
        ...entityKey,
      },
    }),
};
